import * as React from "react";
const SvgSendVariant = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 20V14L11 12L3 10V4L22 12Z" }));
export default SvgSendVariant;
